export default __webpack_public_path__ + "static/media/phone.00daf3a2.svg";